import _sfc_main from "./indexPC.vue2.mjs";
import "./indexPC.vue3.mjs";
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "sidebar-container" }, [_c(_setup.Drawer, { attrs: { "modal": false, "title": _setup.title, "before-close": _setup.handleClose, "size": 400 }, model: { value: _setup.isSidebarOpen, callback: function($$v) {
    _setup.isSidebarOpen = $$v;
  }, expression: "isSidebarOpen" } }, [_setup.sidebarName == "chat" ? _c(_setup.Chat) : _vm._e(), _setup.sidebarName == "more" ? _c(_setup.RoomMore) : _vm._e(), _setup.sidebarName == "manage-member" ? _c(_setup.ManageMember) : _vm._e(), _setup.sidebarName == "aiTranscription" ? _c(_setup.AITranscription) : _vm._e()], 1)], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const indexPc = __component__.exports;
export {
  indexPc as default
};
